interface BankNumberFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  imgSrc: string;
  imgAlt: string;
  label: string;
  bankDigits: string[];
  digitRefs: React.MutableRefObject<(HTMLInputElement | null)[]>;
  handleDigitChange: (value: string, index: number) => void;
}

const BankNumberField = ({
  imgSrc,
  imgAlt,
  label,
  bankDigits,
  digitRefs,
  handleDigitChange,
  required,
  className,
}: BankNumberFieldProps) => {
  return (
    <>
      <label className="block text-sm font-medium mb-1">
        <span className="inline-flex items-center gap-1">
          <img src={imgSrc} alt={imgAlt} className="mr-2 h-4" />
          {label}
        </span>
      </label>
      <div className="flex justify-center gap-5 mb-4">
        {bankDigits.map((digit, idx) => (
          <input
            key={idx}
            type="text"
            maxLength={1}
            value={digit}
            onChange={(e) => handleDigitChange(e.target.value, idx)}
            className={`${className} w-10 h-10 p-2 rounded-md text-black text-center text-lg font-semibold border border-gray-300 focus:outline-none`}
            required={required}
            ref={(el) => (digitRefs.current[idx] = el)}
            onKeyDown={(e) => {
              if (e.key === "Backspace") {
                if (bankDigits[idx] === "" && idx > 0) {
                  e.preventDefault();
                  digitRefs.current[idx - 1]?.focus();
                  const newDigits = [...bankDigits];
                  newDigits[idx - 1] = "";
                  handleDigitChange("", idx - 1);
                } else {
                  const newDigits = [...bankDigits];
                  newDigits[idx] = "";
                  handleDigitChange("", idx);
                }
              }
            }}
            onInvalid={(e) => {
              (e.target as HTMLInputElement).setCustomValidity(
                "Vui lòng nhập số này."
              );
            }}
            onInput={(e) => {
              (e.target as HTMLInputElement).setCustomValidity("");
            }}
          />
        ))}
      </div>
    </>
  );
};

export default BankNumberField;
